import { plural } from '@cian/utils';

import { ETransportType, IOfferUnderground } from 'shared/types/offers';

const TIME: [string, string, string] = ['минута', 'минуты', 'минут'];

export const getUndergroundTimeToGet = (underground: IOfferUnderground): string => {
  const { time, transportType } = underground;
  if (typeof time === 'undefined') {
    return '';
  }

  const text = `${transportType === ETransportType.Walk ? 'пешком' : 'на транспорте'}`;

  return time > 0 ? `${time}\u00A0${plural(time, TIME)}\u00A0${text}` : `\x031\u00A0минуты\u00A0${text}`;
};
